import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const AddAdminModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "AddAdminModalContainer" */
      './AddAdminModalContainer'
    ),
  loading: LoadingModal,
});
